export default __webpack_public_path__ + "static/media/login.02cdca7d.jpg";